export default __webpack_public_path__ + "assets/sounds/a95c3a390824b55cb13ab9cf23d727c6.mp3";